/**
 * Created by iamso on 23.11.2021
 */

const LockedComponentView = cc.Node.extend({
    ctor: function (locked, unitParentView) {
        this._super();

        this.setContentSize2(unitParentView.getContentSize());

        this.locked = locked;
        this.unitView = unitParentView;

        if (cleverapps.environment.isEditorScene()) {
            return;
        }

        this.restoreState();
        cleverapps.bundleLoader.ensureSoundsLoaded([bundles.merge.urls.unitlock_open, bundles.merge.urls.unitlock_start_unlock]);
    },

    restoreState: function () {
        if (this.locked.isUnlocking()) {
            if (!this.timer) {
                this.createTimer();
            }
            this.createSpeedUpButton();
            this.removeButton();
            this.removeDoubleClickListener();
        } else if (this.locked.isLocked()) {
            if (!this.button) {
                this.createButton();
            }
            this.removeTimer();
            this.removeSpeedUpButton();

            if (!this.doubleClickListener) {
                this.doubleClickListener = cleverapps.UI.onClick(this.unitView, () => {
                    if (this.locked.isBlocked()) {
                        Merge2.current.showHint(this.unitView, Messages.get("LockedComponent.blockedHint"));
                    }
                }, {
                    onDoubleClick: () => {
                        if (this.locked.isBlocked()) {
                            Merge2.current.showHint(this.unitView, Messages.get("LockedComponent.blockedHint"));
                        } else {
                            cleverapps.userStatus.reportUserAction();
                            this.locked.startUnlocking();
                        }
                    },
                    interactiveScale: false
                });
            }
        } else {
            this.removeButton();
            this.removeTimer();
            this.removeSpeedUpButton();
            this.removeDoubleClickListener();
        }
    },

    createButton: function () {
        const styles = cleverapps.styles.LockedComponentView;

        this.button = new cleverapps.UI.Button({
            type: {
                button_png: bundles.merge.frames.unlock_button_png,
                button_on_png: bundles.merge.frames.unlock_button_on_png
            },
            onClicked: () => {
                if (this.locked.isBlocked()) {
                    Merge2.current.showHint(this.unitView, Messages.get("LockedComponent.blockedHint"));
                } else {
                    cleverapps.userStatus.reportUserAction();
                    this.locked.startUnlocking();
                }
            }
        });
        this.button.setAlignment(styles.lock);
        this.addChild(this.button, 1);
    },

    removeButton: function () {
        if (this.button) {
            this.button.removeFromParent();
            delete this.button;
        }
    },

    createTimer: function () {
        const styles = cleverapps.styles.LockedComponentView;
        const timer = this.timer = new cleverapps.Spine(bundles.small_timer_merge.jsons.mineable_timer_json);
        timer.setAlignment(styles.lock);
        const animationName = "animation";
        timer.setAnimation(0, animationName, false);
        const left = this.locked.getTimeLeft();
        const total = this.locked.unlockDuration;

        const animationDuration = timer.getAnimationDuration(animationName);

        const progress = (total - left) / total;
        timer.setTrackProgress(progress);
        timer.setTimeScale(animationDuration * 1000 / total);

        this.addChild(timer);
    },

    removeTimer: function () {
        if (this.timer) {
            this.timer.removeFromParent();
            delete this.timer;
        }
    },

    createSpeedUpButton: function () {
        if (this.unitView.hasAdditionalView("speedUpButton")) {
            return;
        }

        const button = new UnitSpeedUpButton(this.locked.getSpeedUpOptions());
        this.unitView.createAdditionalView("speedUpButton", button);
    },

    removeSpeedUpButton: function () {
        this.unitView.removeAdditionalView("speedUpButton");
    },

    removeDoubleClickListener: function () {
        if (this.doubleClickListener) {
            this.doubleClickListener.remove();
            delete this.doubleClickListener;
        }
    }
});

cleverapps.styles.LockedComponentView = {
    lock: {
        x: { align: "right", dx: 0 },
        y: { align: "top", dy: 0 }
    }
};
